/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Cancel_Appstore_NoteInputs */

const en_dialog_cancel_appstore_note = /** @type {(inputs: Dialog_Cancel_Appstore_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NOTE: If you have an app store subscription, please make sure it's canceled as well. We can't cancel mobile app store subscriptions on your behalf.`)
};

const es_dialog_cancel_appstore_note = /** @type {(inputs: Dialog_Cancel_Appstore_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NOTA: Si tienes una suscripción en la tienda de aplicaciones, asegúrate de cancelarla también. No podemos cancelar las suscripciones de la tienda de aplicaciones por ti.`)
};

/**
* | output |
* | --- |
* | "NOTE: If you have an app store subscription, please make sure it's canceled as well. We can't cancel mobile app store subscriptions on your behalf." |
*
* @param {Dialog_Cancel_Appstore_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_cancel_appstore_note = /** @type {((inputs?: Dialog_Cancel_Appstore_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Cancel_Appstore_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_cancel_appstore_note(inputs)
	return en_dialog_cancel_appstore_note(inputs)
});